module.exports = __webpack_public_path__ + "static/media/Status_Verde.ea4b640e.svg";